/* eslint-disable indent */
const timeDifference = (current: number, previous: number) => {
    const milliSecondsPerMinute = 60 * 1000;
    const milliSecondsPerHour = milliSecondsPerMinute * 60;
    const milliSecondsPerDay = milliSecondsPerHour * 24;
    const milliSecondsPerMonth = milliSecondsPerDay * 30;
    const milliSecondsPerYear = milliSecondsPerDay * 365;

    const elapsed = current - previous;

    if (elapsed < milliSecondsPerMinute / 3) {
        return 'Just Now';
    }

    if (elapsed < milliSecondsPerMinute) {
        return 'less than 1 minute ago';
    } if (elapsed < milliSecondsPerHour) {
        return `${Math.round(elapsed / milliSecondsPerMinute)} minutes ago`;
    } if (elapsed < milliSecondsPerDay) {
        return `${Math.round(elapsed / milliSecondsPerHour)} hours ago`;
    } if (elapsed < milliSecondsPerMonth) {
        return `${Math.round(elapsed / milliSecondsPerDay)} days ago`;
    } if (elapsed < milliSecondsPerYear) {
        return `${Math.round(elapsed / milliSecondsPerMonth)} months ago`;
    }
    return `${Math.round(elapsed / milliSecondsPerYear)} years ago`;
};

const timeDifferenceForDate = (date: string) => {
    const now = new Date().getTime();
    const updated = new Date(date).getTime();

    return timeDifference(now, updated);
};

export default timeDifferenceForDate;
